module.exports = __webpack_public_path__ + "static/media/Vector-5.b79d4643.svg";